const content: { [key: string]: any } = {
  permissionRoleGroupAssign: 'Assign Group',
};

export default content;
